import { createReducer } from "redux-act";

import { reducerRegistry } from "../reducerRegistry";
import { reset, setAcl, setLoading, setError } from "./actions";
import { AclState } from "./types";

export { default as saga } from "./sagas";
export * from "./types";
export * from "./actions";

const initialState: AclState = { data: void 0, loading: false, error: null };

export const reducer = createReducer<AclState>({}, initialState);

reducer
  .on(setAcl, (state, data) => {
    return {
      ...state,
      data,
      loading: false,
    };
  })
  .on(setLoading, (state, loading) => {
    return {
      ...state,
      loading,
    };
  })
  .on(setError, (state, error) => {
    return {
      ...state,
      error,
    };
  });

reducer.on(reset, () => initialState);
reducerRegistry.register("acl", reducer);
